import { useTranslation } from "react-i18next";

/** A failed request, said as such (never as "nothing found"), with a way to try again. */
export default function QueryError({ onRetry, message }: { onRetry: () => void; message?: string }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-800">
      <p>{message ?? t("common.loadFailed")}</p>
      <button type="button" className="btn btn-secondary mt-3" onClick={onRetry}>
        {t("common.retry")}
      </button>
    </div>
  );
}
